import Link from "next/link";
import Image from "./image";
import React from "react";

export const FeaturedHero = ({ Hero }) => {
  return (
    <div className={`grid lg:grid-cols-2 my-4`}>
      <div className="flex lg:hidden flex-col items-center justify-center overflow-hidden">
        <Image alt={""} image={Hero?.image} />
      </div>
      <div className={`flex flex-col items-center`}>
        <div className={`bg-[#201E50] text-white w-full p-6 lg:p-16`}>
          <h1
            className={`font-display font-bold text-[28px] leading-none block`}
          >
            {Hero.hero}
          </h1>
        </div>
        <div className={`bg-[#201E50] text-white w-full p-6 lg:p-16`}>
          <h1
            className={`font-display font-bold text-[28px] leading-none block`}
          >
            {Hero.title}
          </h1>
          <p className={`font-display text-[16px] my-4`}>{Hero.content}</p>
          <p className={`font-display text-[16px]`}>Call for pricing</p>
          <div className={`mt-16`}>
            <Link href={Hero.uri || ""}>
              <a
                className={`font-display border border-white py-2 px-4 rounded-full border-2 hover:text-black hover:bg-white uppercase`}
              >
                View Options
              </a>
            </Link>
          </div>
        </div>
      </div>
      <div className="hidden lg:flex flex-col items-center justify-center overflow-hidden">
        <Image alt={""} image={Hero?.image} />
      </div>
    </div>
  );
};
